import { SyntheticEvent } from 'react';
import { Box, Button } from '@bridebook/ui';
import { IconBookmark, IconBookmarkFilled } from '@bridebook/ui/src/icons';
import componentStyles from './bookmark-flag.style';

interface IProps {
  isBookmarked: boolean;
  onBookmarkClicked: (e: SyntheticEvent<unknown>) => unknown;
  width?: number;
  height?: number;
}

const BookmarkFlag = ({ isBookmarked, onBookmarkClicked, width, height }: IProps) => {
  const styles = componentStyles(width, height);

  return (
    <Box style={styles.wrapper}>
      <Button
        theme="ghost"
        color="space"
        customWidth={width ? width : 55}
        customHeight={height ? height : 55}
        icon={
          isBookmarked ? (
            <IconBookmarkFilled color="space" width={10} />
          ) : (
            <IconBookmark color="space" width={10} />
          )
        }
        onClick={onBookmarkClicked}
      />
    </Box>
  );
};

export default BookmarkFlag;
